<template>
  <div class="m-2">
    <arq-previews-page />
    <h1>Cambio De Tercero</h1>
    <form class="w-50 lg:w-25 mx-auto my-4">
      <div class="card p-2">
        <div
          v-for="(f, index) in form"
          :key="index"
        >
          <label :for="f.key">
            {{ f.label }}
          </label>
          <div v-if="types.includes(f.type)">
            <div v-if="f.key.includes('identification')">
              <b-form-input
                :id="f.key"
                v-model="data[f.key]"
                :name="f.key"
                :type="f.type"
                :required="f.required"
                :disabled="f.disabled"
                @input="getContract(data[f.key])"
              />
            </div>
            <div v-if="f.key.includes('phone')">
              <b-form-input
                :id="f.key"
                v-model="phone"
                :name="f.key"
                :type="f.type"
                :required="f.required"
                :disabled="f.disabled"
              />
            </div>
            <div v-if="f.key.includes('email')">
              <b-form-input
                :id="f.key"
                v-model="email"
                :name="f.key"
                :type="f.type"
                :required="f.required"
                :disabled="f.disabled"
              />
            </div>
            <b-form-input
              v-if="
                !f.key.includes('email') &&
                  !f.key.includes('phone') &&
                  !f.key.includes('identification')
              "
              :id="f.key"
              v-model="data[f.key]"
              :name="f.key"
              :type="f.type"
              :required="f.required"
              :disabled="f.disabled"
            />
          </div>
          <div v-if="f.type === 'select-contract'">
            <b-form-select
              :id="f.key"
              v-model.number="data[f.key]"
              value-field="idProducto"
              text-field="descservicio"
              :options="contratos"
              @input="getOptionServices(data[f.key])"
            />
          </div>
          <div v-if="f.type === 'select-typeDocument'">
            <b-form-select
              :id="f.key"
              v-model.number="data[f.key]"
              value-field="id"
              text-field="description"
              :options="documentTypes"
            />
          </div>
          <!-- v-model="data[f.key]" -->
          <b-form-file
            v-if="f.type === 'file'"
            :id="f.key"
            :state="Boolean(data[f.key])"
            placeholder="Adjuntar documento..."
            drop-placeholder="Suelta el documento aqui..."
            @input="uploadImage()"
          />
          <div v-if="f.type === 'textarea'">
            <b-form-textarea
              :id="f.key"
              v-model="data[f.key]"
              rows="8"
            />
          </div>
        </div>
        <div class="col-12">
          <b-button
            :disabled="disabledButton"
            variant="primary"
            class="mt-3 d-flex text-center w-100 mr-auto ml-auto justify-content-center"
            @click="confirm()"
          >
            <div v-if="loading">
              <b-spinner
                small
                class="mr-1"
                label="Small Spinner"
              />
            </div>
            Confirmar
          </b-button>
        </div>
      </div>
    </form>
    <b-modal
      id="modal-confirm-process"
      title="Tramite"
      ok-only
    >
      <div v-if="!response.message">
        <p class="my-4">
          <b-spinner
            variant="success"
            label="Spinning"
          />
          Enviando solicitud!
        </p>
      </div>
      <div v-else>
        <b-alert
          :variant="response.variant"
          show
        >
          {{ response.message }}
        </b-alert>
      </div>
    </b-modal>
    <b-modal
      id="modal-actualizar-datos-personales"
      title="Actualizar datos personales"
      hide-footer
    >
      <!-- ok-title="Confirmar"
      cancel-title="Cancelar"
      @ok="handleOk" -->
      <div v-if="!responseUpdatePersonal.message">
        <b-alert
          variant="danger"
          show
        >
          Necesita actualizar los datos personales
        </b-alert>
        <form
          ref="formActualizarDatosPersonales"
          @submit.stop.prevent="handleSubmit"
        >
          <!-- <b-form-group
            label="Identifiacion"
            label-for="identifiacion-input"
            invalid-feedback="Identificacion es requerida"
            :state="identificacionState"
          >
            <b-form-input
              id="identifiacion-input"
              v-model="dataPersonal.identificacion"
              required
              type="number"
              :state="identificacionState"
            />
          </b-form-group> -->
          <b-form-group
            label="Telefono"
            label-for="phone-input"
            invalid-feedback="Telefono es requerido"
            :state="phoneState"
          >
            <b-form-input
              id="phone-input"
              v-model="dataPersonal.celularespo"
              max-length="10"
              min-length="10"
              required
              type="number"
              :state="phoneState"
            />
          </b-form-group>
          <b-form-group
            label="Correo"
            label-for="email-input"
            invalid-feedback="Email es requerido"
            :state="emailState"
          >
            <b-form-input
              id="email-input"
              v-model="dataPersonal.emailresposerv"
              required
              type="email"
              :state="emailState"
            /></b-form-group>
        </form>
        <button
          class="bg-primary text-white m-auto mr-auto btn"
          style="position: relative; margin-left: 12em !important;"
          @click.prevent="handleOk"
        >
          Confirmar
        </button>
      </div>
      <div v-else>
        <b-alert
          :variant="responseUpdatePersonal.variant"
          show
        >
          a {{ responseUpdatePersonal.message }}
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Ripple from 'vue-ripple-directive'
import { BSpinner } from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  components: {
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      form: [
        {
          label: 'Contrato',
          key: 'contrato',
          type: 'select-contract',
          required: true,
        },
        {
          label: 'Tipo de documento',
          key: 'typeIdentification',
          type: 'select-typeDocument',
          required: true,
        },
        {
          label: 'Nueva Identificación',
          key: 'numberIdentification',
          type: 'number',
          required: true,
        },
        {
          label: 'Celular',
          key: 'phone',
          type: 'number',
          disabled: true,
          required: true,
        },
        {
          label: 'Correo',
          key: 'email',
          type: 'text',
          disabled: true,
          required: true,
        },
        {
          label: 'Seleccione un archivo',
          key: 'fileBase64',
          type: 'file',
          disabled: true,
          required: true,
        },
        {
          label: 'Descripcion',
          key: 'descripcion',
          type: 'textarea',
          required: true,
        },
      ],
      data: {},
      types: [
        'text',
        'number',
        'email',
        'password',
        'search',
        'url',
        'tel',
        'date',
        'time',
        'range',
        'color',
      ],
      optionsServices: [],
      idService: 0,
      imageSrc: '',
      fileType: '',
      fileName: '',
      disabledButton: false,
      documentTypes: [],
      phone: '',
      email: '',
      process: {},
      responseUpdatePersonal: {},
      phoneState: false,
      emailState: false,
      response: {},
      dataPersonal: {},
    }
  },
  computed: {
    ...mapState('client', ['contratos']),
  },
  created() {
    this.consultaDocumentTypes()
  },
  mounted() {
    this.data.identificacion = this.$store.state.client.client.identificacion
  },
  methods: {
    getContract(id) {
      this.contratos = []
      axios.get(`/client/contracts/${1}/${id}`).then(res => {
        this.contratos = res.data.list
      })
    },
    getOptionServices(contrato) {
      this.phone = ''
      this.email = ''
      axios
        .get(`/app/services/fromContract?idContract=${contrato}`)
        .then(res => {
          if (res.data.code === 0) {
            this.optionsServices = res.data.list
            this.idService = res.data.object.idProductoDefault
            this.phone = res.data.object.celularespo
            this.email = res.data.object.emailresposerv
          } else {
            this.optionsServices = []
          }
        })
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      let validate = false
      // if (!this.dataPersonal.identificacion) {
      //   validate = this.checkFormValidity()
      //   if (!validate) {
      //     // console.log('blos')
      //     return false
      //   }
      //   return false
      // }
      if (!this.dataPersonal.celularespo && !this.dataPersonal.emailresposer) {
        validate = this.checkFormValidity()
        if (!validate) {
          // this.identificacionState = true
          // console.log('blos')
          return false
        }
      }

      // Prevent modal from closing
      validate = this.checkFormValidity()
      this.phoneState = true
      this.emailState = true
      // this.identificacionState = true
      // console.log('bla')
      this.dataPersonal.identificacion = this.data.identification
      axios
        .post('/app/person/update', this.dataPersonal)
        .then(res => {
          if (res.data.code === 0) {
            this.responseUpdatePersonal.message = 'Sus datos han sido actualizados exitosamente.'
            this.responseUpdatePersonal.variant = 'success'
            this.data = {}
          } else {
            this.responseUpdatePersonal.message = 'Error al intentar actualizar los datos.'
            this.responseUpdatePersonal.variant = 'danger'
          }
        })
        .finally(() => {
          this.dataPersonal = {}
        })
      this.$nextTick(() => {
        this.$bvModal.hide('modal-actualizar-datos-personales')
      })
      return true
      // Trigger submit handler
    },
    checkFormValidity() {
      const valid = this.$refs.formActualizarDatosPersonales.checkValidity()
      return valid
    },
    openActualizacionDatos() {
      this.$bvModal.show('modal-actualizar-datos-personales')
    },
    confirm() {
      if (
        this.phone === ''
        || this.phone === null
        || !this.phone
        || !this.email
        || this.email === ''
        || this.email === null
      ) {
        this.openActualizacionDatos()
        return
      }
      this.loading = true
      this.disabledButton = true
      this.data.idService = this.idService
      this.data.fileName = this.fileName
      this.data.fileType = this.fileType
      this.data.phone = this.phone
      this.data.email = this.email
      this.sendGetProcedure(this.data)
        .then(res => {
          if (res.code === 0) {
            this.response.message = res.data.msg || 'Su tramite ha sido enviado'
            this.response.variant = 'success'
            this.response.title = '¡Iformación!'
            this.data = {}
          } else {
            this.response.message = 'Error al crear el tramite'
            this.response.variant = 'danger'
            this.response.title = '¡Alerta!'
          }
          this.$bvModal.show('modal-confirm-process')
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: 'Mensaje',
          //     icon: 'AlertOctagonIcon',
          //     text: res.data.msg,
          //     variant: 'warning',
          //   },
          // })

          document.querySelector('input[type=file]').value = ''
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          this.disabledButton = false
        })
    },

    async sendGetProcedure(formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/app/procedure/cambioTercero', formData)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    uploadImage() {
      const file = document.querySelector('input[type=file]').files[0]
      this.imageSrc = file
      this.fileType = file.type
      this.fileName = file.name
      const reader = new FileReader()
      reader.onload = e => {
        if (e.target.result) {
          this.data.fileBase64 = e.target.result
        }
      }
      reader.onerror = function (error) {
        alert(error)
      }
      reader.readAsDataURL(file)
    },
    consultaDocumentTypes() {
      axios.get('/app/client/documenttypes').then(res => {
        this.documentTypes = res.data.list
      })
    },
  },
}
</script>
